export default "__VITE_ASSET__DIHf61gG__"